import context from '@/providers/context'
import * as routing from '@/providers/routing'
import Dashboard from './Dashboard'
import Apps from './Apps'
import Login from './Login'
import AdminReports from './AdminReports'
import BountyList from './BountyList'
import BountyDetail from './BountyDetail'
import Companies from './Companies'
import CompanyProfile from './CompanyProfile'
import Invoices from './Invoices'
import InvoiceDetail from './InvoiceDetail'
import Transaction from './Transaction'
import _ from 'lodash'

//APPS
import * as contestdream from '@/apps/contestdream'
import * as gamify from '@/apps/gamify'
import * as loyaltyvenue from '@/apps/loyaltyvenue'
import * as swee from '@/apps/swee'
import * as mcaudience from '@/apps/mcaudience'
import * as feelgrid from '@/apps/feelgrid'
import * as aquest from '@/apps/aquest'
import * as bounty from '@/apps/bounty'
var apps = { contestdream, gamify, loyaltyvenue, swee, mcaudience, feelgrid, aquest, bounty };



//base apps route
var appsroutename = 'apps';

//routes from all apps
var apps_routes = _.mapValues(apps, app => app.routes.map(rt => {
    var route = Object.assign({}, rt);
    route.path = 'apps/' + route.path.ltrim('/');
    route.meta = Object.assign({
        up: appsroutename,
    }, route.meta || {});
    return route;
}));

//ROUTES
export const routes = [{
            path: '/',
            name: 'dashboard',
            component: Dashboard,
            meta: {
                trans: 'titles.dashboard',
                icon: 'dashboard',
            },
        },
        {
            path: '/apps',
            name: appsroutename,
            component: Apps,
            meta: {
                trans: 'titles.apps',
                icon: 'apps',
            },
        },
        {
            path: '/login',
            name: 'login',
            component: Login,
            meta: {
                priority: 1000,
                trans: 'login',
                root: true,
            }
        },
        {
            path: '/reports',
            name: 'admin.reports',
            component: AdminReports,
            meta: {
                trans: 'titles.reports',
                icon: 'bargraph',
                restrict: context => context.getters.admin,
            }
        },
        {
          path: '/bountylist',
          name: 'admin.bountylist',
          component: BountyList,
          meta: {
            trans: 'Bounty List',
            icon: 'apps',
            restrict: context => context.getters.admin,
          },
        },
        {
          path: '/bountydetail',
          component: BountyDetail,
          name: 'admin.bountydetail',
          meta: {
            up: 'admin.bountylist',
            trans: 'Bounty Detail',
          },
        },
        {
          path: '/companies',
          name: 'admin.companies',
          component: Companies,
          meta: {
            trans: 'Companies',
            icon: 'building',
            restrict: context => context.getters.admin,
          },
        }, {
          path: '/companies/:id',
          name: 'admin.companyprofile',
          component: CompanyProfile,
          meta: {
            trans: 'Company Profile',
            up: 'admin.companies',
          },
        },
        {
          path: '/invoices',
          name: 'admin.invoices',
          component: Invoices,
          meta: {
            trans: 'Invoices',
            icon: 'bargraph',
            restrict: context => context.getters.admin,
          },
        },
        {
          path: '/invoices/:id',
          name: 'admin.invoicesdetail',
          component: InvoiceDetail,
          meta: {
            trans: 'users:user',
            up: 'admin.invoices',
          },
        },
        {
          path: '/transaction/:id',
          name: 'admin.invoicesdetail.transaction',
          component: Transaction,
          meta: {
            trans: 'Transaction Invoices',
            up: 'admin.invoices',
          },
        },
    ]
    //add routes from apps
    .concat(_.flatten(Object.values(apps_routes)));

//ROUTING
export function guard(router) {

    var getHashQuery = (exclude) => {
        var hash = window.location.hash;
        if (hash.length > 1) {
            while (hash[0] === '/' || hash[0] === '#') {
                hash = hash.substring(1);
            }
            if (hash.length) {
                if (exclude && hash.substring(0, exclude.length) === exclude) {
                    return {};
                }
                return { redirect: hash };
            }
        }
        return {};
    };

    //watch: if user is empty, redirect to login
    context.watch((state) => state.user, function(user) {
        if (user !== undefined && !user.length) {
            return router.push({ name: 'login', query: getHashQuery('login') });
        }
    });

    router.beforeResolve((to, from, next) => {
        if (!context.getters.logged && to.name !== 'login') {
            console.log('Guard: User is not logged in.');
            return routing.priorityNext(to, { name: 'login', query: getHashQuery('login') }, next, router);
        }

        context.getters.async('user').then((user) => {
            if (!user.length && to.name !== 'login') {
                console.log('Guard: User is not found. Redirecting to login.');
                return next({ name: 'login', query: getHashQuery('login') })
            } else if (user.length && to.name === 'login') {
                console.log('Guard: User is already logged in.');
                return next({ name: 'dashboard' });
            }
            return next();
        }).catch(() => next());

        context.getters.async('admin').then(is_admin => {
            if (!is_admin && to.name.split('.')[0] === 'admin') {
                console.log('Guard: User is not admin and cannot access admin routes.');
                return next({ name: 'dashboard' });
            }
            return next();
        }).catch(() => next());
    });

    //Add app guards to router
    for (let app of Object.values(apps)) {
        if (app.hasOwnProperty('guard')) {
            app.guard(router);
        }
    }

    //change body class when entering/exiting app
    router.afterEach((to, from) => {
        //gets app name for route
        var getAllRoutes = function(routes) {
            var result = routes;
            for (let r of routes) {
                result = result.concat(getAllRoutes(r.children || (r.meta && r.meta.children) || []));
            }
            return result;
        };
        var getAppName = function(route) {
            if (!route.name) {
                return false;
            }
            for (let appname in apps_routes) {
                //ccompare apps routes names with given route name
                if (getAllRoutes(apps_routes[appname]).map(r => r.name || null).includes(route.name)) {
                    return appname;
                }
            }
            return false;
        };
        var nameFrom = getAppName(from);
        var nameTo = getAppName(to);

        if (nameFrom === nameTo) {
            return;
        }
        if (nameFrom) {
            document.body.classList.remove(nameFrom);
        }
        if (nameTo) {
            document.body.classList.add(nameTo);
        }
    });
}

// TRANSLATIONS
import en from './i18n/en'
import it from './i18n/it'
import sl from './i18n/sl'
import de from './i18n/de'
import fr from './i18n/fr'
import i18n from '@/providers/i18n'

for (let [lang, bundle] of Object.entries({ en, it, sl, de, fr })) {
    i18n.i18next.addResourceBundle(lang, 'general', bundle);
}


// WEBPACK FOOTER //
// ./src/sections/general/index.js